import Vue from 'vue'
import Router from 'vue-router'
const Index = () => import('@/components/index.vue')
const List = () => import('@/components/list.vue')
const Details = () => import('@/components/details.vue')
const Login = () => import('@/components/login.vue')
const Register = () => import('@/components/register.vue')
const ShoppingCart = () => import('@/components/shoppingCart.vue')
const Settlement = () => import('@/components/settlement.vue')
const Cashier = () => import('@/components/cashier.vue')
const Order = () => import('@/components/order.vue')
const ForgetPassWord = () => import('@/components/forgetPassword')
const Service = () => import('@/components/service')
const ServiceList = () => import('@/components/serviceList')
const ServiceDetails = () => import('@/components/serviceDetails')
const Service2 = () => import('@/components/service2')
const Hotel = () => import('@/components/hotel')
const HotelDetails = () => import('@/components/hotelDetails')
const Card = () => import('@/components/card')
const Shop = () => import('@/components/shop')
const Brand = () => import('@/components/brand')
const Information = () => import('@/components/information')
const Purchase = () => import('@/components/purchase/purchase')
const Tender = () => import('@/components/purchase/tender')
const Win = () => import('@/components/purchase/win')
const Help = () => import('@/components/purchase/Help')
const TenderDetail = () => import('@/components/purchase/TenderDetail')
const SupplierRegister = () => import('@/components/purchase/supplierRegister')

const Text1 = () => import('@/components/text')

Vue.use(Router)

let router =  new Router({
    mode : 'history',
    routes: [
        {
            name : 'Home',
            path : '/',
            component : Index
        },
        {
            name : 'List',
            path : '/list',
            component : List
        },
        {
            name : 'Details',
            path : '/details/:id',
            component : Details
        },
        {
            name : 'Login',
            path : '/login',
            component : Login
        },
        {
            name : 'Register',
            path : '/register',
            component : Register
        },
        {
            name : 'ShoppingCart',
            path : '/shoppingcart',
            component : ShoppingCart
        },
        {
            name : 'Settlement',
            path : '/settlement/:orderId',
            component : Settlement
        },
        {
            name : 'Cashier',
            path : '/cashier',
            component : Cashier
        },
        {
            name : 'Order',
            path : '/order',
            component : Order
        },
        {
            name : 'ForgetPassWord',
            path : '/forgetpassword',
            component : ForgetPassWord
        },
        {
            name : 'Service',
            path : '/service',
            component : Service
        },
        {
            name : 'Service2',
            path : '/service2',
            component : Service2
        },
        {
            name : 'ServiceList',
            path : '/serviceList/:serviceId',
            component : ServiceList
        },
        {
            name : 'ServiceDetails',
            path : '/serviceDetails',
            component : ServiceDetails
        },
        {
            name : 'Hotel',
            path : '/hotel',
            component : Hotel
        },
        {
            name : 'HotelDetails',
            path : '/hotelDetails/:id',
            component : HotelDetails
        },
        {
            name : 'Card',
            path : '/card',
            component : Card
        },
        {
            name : 'Shop',
            path : '/shop/:categoryId',
            component : Shop
        },
        {
            name : 'Brand',
            path : '/brand',
            component : Brand
        },
        {
            name : 'Text',
            path : '/text',
            component : Text1
        },
        {
            name : 'Information',
            path : '/information',
            component : Information
        },
        {
            name : 'Purchase',
            path : '/purchase',
            component : Purchase
        },
        {
            name : 'Tender',
            path : '/tender',
            component : Tender
        },
        {
            name : 'Win',
            path : '/win',
            component : Win
        },
        {
            name : 'Help',
            path : '/help',
            component : Help
        },
        {
            name : 'TenderDetail',
            path : '/tenderDetail/:id',
            component : TenderDetail
        },
        {
            name : 'SupplierRegister',
            path : '/supplierregister',
            component : SupplierRegister
        }
    ],
  scrollBehavior(to, from, savedPosition) {
      return {x : 0, y : 0}
  }
})

router.beforeEach((to, from, next) => {
    let token = sessionStorage.getItem('token');
    if(token) {
        if(to.name === 'Login' || to.name === 'Register') {
            alert('您已处于登录状态');
            router.push({
                name : 'Home'
            })
            .catch((err) => {
                console.log(err);
            })
        }else{
            next();
        }
    }else{
        next();
    }
})  


export default router;


// WEBPACK FOOTER //
// ./src/router/index.js